import { TFilters } from "@common/components/ResidenceGeneric/Filters"
import { create } from "zustand"

export type SortConfig = {
  field: string | null
  direction: string
}

const initialSortConfig: SortConfig = {
  field: null,
  direction: "ascending",
}

export const initialFilters: TFilters = {
  floor: [0, Infinity],
  price: [0, Infinity],
  beds: [],
  topologies: [],
}

interface InitialState {
  availabilityData: any[]
  residencePopup: boolean
  compareMode: boolean
  compareSection: string
  selectedRows: any[]
  orbitIndex: number
  contentIndex: number
  selectedUnit: any
  imageOverlay: string
  residenceStyleIndex: number
  residenceViewFullscreen: boolean
  galleryImagesIndex: number
  setContentIndex: (index: number) => void
  syncState: (stateToUpdate: any) => void
  contentControls: any
  filteredUnits: any
  sortConfig: SortConfig
  filters: TFilters
  tableVisible: boolean
  aboutIndex: number
  categoriesVisible: boolean
  splashPage: boolean
  controlsVisible: boolean
  selectedPhase: string
}

export const useStore = create<InitialState>((set) => ({
  availabilityData: [],
  controlsVisible: false,
  orbitIndex: 0,
  filteredUnits: null,
  contentControls: {
    index: 0,
    categories: [],
  },
  selectedUnit: null,
  galleryImagesIndex: null,
  residenceStyleIndex: 0,
  residenceViewFullscreen: false,
  sortConfig: initialSortConfig,
  filters: initialFilters,
  imageOverlay: null,
  contentIndex: 0,
  compareMode: false,
  compareSection: "floorplan",
  selectedRows: [null, null],
  residencePopup: false,
  tableVisible: false,
  aboutIndex: 0,
  categoriesVisible: false,
  splashPage: true,
  selectedPhase: "phase1",

  syncState: (stateToUpdate) => {
    set({ ...stateToUpdate })
  },
  setContentIndex: (index) => {
    set({ contentIndex: index })
  },
}))
